import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/#speakers", label: "Speakers" },
    { to: "/#schedule", label: "Schedule" },
    { to: "/#tickets", label: "Tickets" },
    { to: "/#faq", label: "FAQ" },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-50 px-4 sm:px-6 lg:px-10 pt-4" data-testid="main-nav">
      <nav className="dftb-glass rounded-full max-w-6xl mx-auto px-5 sm:px-7 py-3 flex items-center justify-between ring-1 ring-black/5">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <div className="leading-none">
            <div className="flex items-baseline gap-0.5">
              <span className="font-heading text-2xl font-black text-[#212121] tracking-tight">DFTB</span>
              <span className="font-heading text-2xl font-black text-[#28BBE3] tracking-tight relative">
                26
                <span className="absolute -top-1 right-0 h-1.5 w-1.5 rounded-full bg-[#28BBE3]" />
              </span>
              <span className="ml-1.5 hidden sm:inline-block text-[10px] uppercase tracking-[0.22em] text-slate-500 font-semibold">Virtual</span>
            </div>
            <div className="text-[10px] sm:hidden uppercase tracking-[0.22em] text-slate-500 font-semibold mt-0.5">Virtual</div>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-7 text-sm text-slate-600">
          {links.map((l) => (
            <a key={l.to} href={l.to} className="hover:text-slate-900 transition-colors" data-testid={`nav-link-${l.label.toLowerCase()}`}>
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          {user ? (
            <>
              <Button variant="ghost" className="rounded-full" onClick={() => navigate("/portal")} data-testid="nav-portal-btn">
                Portal
              </Button>
              <Button variant="outline" className="rounded-full border-slate-300" onClick={async () => { await logout(); navigate("/"); }} data-testid="nav-logout-btn">
                Sign out
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" className="rounded-full" onClick={() => navigate("/login")} data-testid="nav-login-btn">
                Log in
              </Button>
              <Button className="rounded-full bg-[#28BBE3] hover:bg-[#1FA8CC] text-white px-5" onClick={() => navigate("/#tickets")} data-testid="nav-cta-btn">
                Get tickets
              </Button>
            </>
          )}
        </div>

        <button className="md:hidden p-2 text-slate-700" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="mobile-menu-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden mt-2 dftb-glass rounded-3xl max-w-6xl mx-auto p-4 ring-1 ring-black/5" data-testid="mobile-menu">
          <div className="flex flex-col gap-3">
            {links.map((l) => (
              <a key={l.to} href={l.to} onClick={() => setOpen(false)} className="text-sm text-slate-700 py-1">{l.label}</a>
            ))}
            {user ? (
              <>
                <Button onClick={() => { setOpen(false); navigate("/portal"); }} className="rounded-full bg-[#28BBE3] text-white">Portal</Button>
                <Button variant="outline" className="rounded-full" onClick={async () => { setOpen(false); await logout(); navigate("/"); }}>Sign out</Button>
              </>
            ) : (
              <>
                <Button variant="ghost" onClick={() => { setOpen(false); navigate("/login"); }} className="rounded-full">Log in</Button>
                <Button onClick={() => { setOpen(false); navigate("/#tickets"); }} className="rounded-full bg-[#28BBE3] text-white">Get tickets</Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
